'use strict';

(function () {
    angular
        .module('tracking')
        .directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})        
        .component('trackingSearchPanel', {
            templateUrl: 'tracking/components/tracking-search-panel-component.tpl.html',
            controller: function ($timeout, $scope, $stateParams,applicationConstants,TrackingModel,TrackingHelper) {
                var vm = this;
                vm.isSearchPanelOpen = true;

                vm.model = {
                    fromDate: '',
                    toDate: '',
                    airport: '',
                    aircraftModel: '',
                    crewBase: '',
                    flightNumber : '',
                    crewType : '',
                    timeZone: 'UTC',
                    viewOption: ''
                };

                vm.fromMaxdate = new Date();
                vm.fromMaxdate.setFullYear(new Date().getFullYear() + 2);

                vm.fromMindate = new Date();
                vm.fromMindate.setFullYear(new Date().getFullYear() - 2);

                vm.toMinDate = new Date();
                vm.toMinDate.setFullYear(new Date().getFullYear() - 2);

                vm.toMaxDate = new Date();
                vm.toMaxDate.setFullYear(new Date().getFullYear() + 2);

                vm.fromDateOptions = {
                    minDate : vm.fromMindate,
                    maxDate: vm.fromMaxdate
                };

                vm.toDateOptions = {
                    minDate : vm.toMinDate,
                    maxDate : vm.toMaxDate
                };

                vm.$onInit = function () {
                    setSearchDefaults();

                    TrackingModel.airportsList.subscribe(function (airports) {
                        vm.airportsList = airports;
                    });

                    TrackingModel.aircraftTypes.subscribe(function (aircraftTypes) {
                        vm.aircraftTypeList = aircraftTypes;
                    });

                    TrackingModel.crewBase.subscribe(function (crewBase) {
                        vm.crewBaseList = crewBase;
                    });

                    TrackingModel.crewTypes.subscribe(function (crewTypes) {
                        vm.crewTypes = crewTypes;

                        if(!!$stateParams.crewType){
                            vm.model.crewType = _.find(vm.crewTypes , {crewTypeCode : $stateParams.crewType});
                        }

                    });
                }

                vm.onSearchClick = function () {
                    TrackingHelper.updateFlightSearchCriteria(vm.model);
                };

                vm.onFromDateChange = function () {
                    updateToDateConstrains();
                };

                vm.onToDateChange = function () {
                    updateFromDateConstrains();
                };

                vm.onSearchPanelClick = function () {
                    vm.isSearchPanelOpen = !vm.isSearchPanelOpen
                };

                vm.onTimeZoneChange = function (timeZone) {
                    if (timeZone) {
                        vm.model.timeZone = 'LCL';
                    } else {
                        vm.model.timeZone = 'UTC';
                    }
                }

                function updateFromDateConstrains(){
                    var toDate = moment(vm.model.toDate,applicationConstants.SETTINGS.DATE_FORMAT).toDate();
                    vm.fromMaxdate.setDate(toDate.getDate());
                    vm.fromMaxdate.setMonth(toDate.getMonth());
                    vm.fromMaxdate.setFullYear(toDate.getFullYear());
                }

                function updateToDateConstrains(){
                    var fd = moment(vm.model.fromDate,applicationConstants.SETTINGS.DATE_FORMAT).toDate();
                    vm.model.toDate = vm.model.fromDate;
                    vm.toMinDate.setDate(fd.getDate());
                    vm.toMinDate.setMonth(fd.getMonth());
                    vm.toMinDate.setFullYear(fd.getFullYear());
                }

                function setSearchDefaults() {
                    if (!!$stateParams.day) {
                        vm.model.fromDate = $stateParams.day.replace(/\-/g,'/');
                    }else{
                        vm.model.fromDate = moment().format(applicationConstants.SETTINGS.DATE_FORMAT);
                    }
                    vm.model.toDate =  vm.model.fromDate;
                    updateToDateConstrains();

                    //Do Search if preselected date available
                    if (!!$stateParams.day) {
                        $timeout(function () {
                            vm.onSearchClick();
                        },1000);
                    }
                }
            },
            bindings: {
                isSearchPanelOpen: '=',
                onSearchPanelOpen: '&'
            }
        });
})
();
